import 'is-in-viewport'

const animateInViewportClasses = [
  'move-up-in-viewport',
  'move-down-in-viewport',
  'move-left-in-viewport',
  'move-right-in-viewport',
  'fade-in-in-viewport',
  'zoom-in-in-viewport',
  'active-in-viewport',
  'full-width-in-viewport',
  'animate-in-in-viewport',
  'slide-in-in-viewport',
]

let didScroll = false
let scrollTimeout
let windowHeight

$(function () {
  windowHeight = $(window).height()

  animateInViewport()
  // updateStyle()
})

$(window).scroll(function () {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function () {
      animateInViewport()
      didScroll = true
      scrollTimeout = null // Reset timeout
      // updateStyle()
    }, 100) // Delay in milliseconds
  }
})

$(window).resize(function () {
  windowHeight = $(window).height()
})

function updateStyle() {
  const $blocks = $('[class*="styled-block"]')

  let tallestBlock = null
  $blocks.each(function () {
    const $this = $(this)
    const height = getHeightInViewport($this)
    if (!tallestBlock || height > tallestBlock.height) {
      tallestBlock = {
        element: $this,
        height,
      }
    }
  })

  if (tallestBlock) {
    if (tallestBlock.element.attr('data-style')) {
      $('body').removeClass(function (index, className) {
        return (className.match(/(^|\s)style-\S+/g) || []).join(' ')
      })

      $('body').addClass('style-' + tallestBlock.element.attr('data-style'))
    }
  }
}

export function animateInViewport() {
  $(animateInViewportClasses.map((cls) => `.${cls}`).join(','))
    .filter(':not(.wait-to-animate)')
    .each(function () {
      const $this = $(this)

      if ($this.is(':in-viewport')) {
        $this.addClass('active')
      }
    })
}

function getHeightInViewport($el) {
  var elementHeight = $el.outerHeight(),
    H = windowHeight,
    r = $el[0].getBoundingClientRect(),
    t = r.top,
    b = r.bottom
  return Math.max(0, t > 0 ? Math.min(elementHeight, H - t) : Math.min(b, H))
}
